import { notification } from "antd";
/** SQLSTATE → символ, когда `details` пуст (identifiers.md §5, §8). */
const CODE_TO_SYMBOL = {
    CP001: "CORP_COMPANY_NOT_FOUND",
    CP002: "CORP_COMPANY_NOT_ACTIVE",
    CP003: "CORP_LINK_NOT_ACTIVE",
    CP004: "CORP_LINK_EXPIRES_BEFORE_SCHEDULE",
    CP005: "CORP_CREDIT_LIMIT_EXCEEDED",
    CP006: "CORP_TARIFF_MISMATCH",
    CP007: "CORP_CARD_NOT_ALLOWED",
    CP008: "CORP_PAYER_IMMUTABLE",
    CP009: "CORP_PAYMENT_STATUS_NOT_ALLOWED",
    CP010: "CORP_KWH_REQUIRED",
    CP011: "CORP_FINANCIALS_LOCKED",
    CP012: "CORP_ACTOR_FORBIDDEN",
    CP013: "CORP_DELETE_CHARGED_ORDER",
    CP014: "CORP_ORDER_STATUS_INVALID",
    CP015: "CORP_LEDGER_IMMUTABLE",
    CP016: "CORP_ORDER_COMPLETED_ON_INSERT",
    CP101: "CORP_PHONE_INVALID",
    CP102: "CORP_CLIENT_NOT_FOUND",
    CP103: "CORP_PHONE_AMBIGUOUS",
    CP104: "CORP_LINK_OVERLAP",
    CP105: "CORP_LINK_PERIOD_INVALID",
    CP106: "CORP_RATE_LIMITED",
    CP107: "CORP_LINK_BLOCKED_BY_STAFF",
    CP301: "CORP_AMOUNT_INVALID",
    CP302: "CORP_INVOICE_EXISTS",
    CP303: "CORP_INVOICE_NOT_VOIDABLE",
    CP304: "CORP_PAYMENT_ALREADY_VOIDED",
    CP305: "CORP_COMPANY_HAS_OPEN_ORDERS",
};
/** Символ → смысл сообщения (spec/05-dispatcher-ui.md §4). */
const SYMBOL_TEXT = {
    CORP_COMPANY_NOT_FOUND: "Компания не найдена — обновите страницу",
    CORP_COMPANY_NOT_ACTIVE: "Компания приостановлена или в архиве — действие недоступно",
    CORP_LINK_NOT_ACTIVE: "У клиента нет действующей привязки к компании",
    CORP_LINK_EXPIRES_BEFORE_SCHEDULE: "Срок привязки сотрудника заканчивается раньше плановой даты заказа",
    CORP_CREDIT_LIMIT_EXCEEDED: "Кредитный лимит компании исчерпан",
    CORP_TARIFF_MISMATCH: "Тариф не относится к этой компании",
    CORP_CARD_NOT_ALLOWED: "К корпоративному заказу нельзя привязать банковскую карту",
    CORP_PAYER_IMMUTABLE: "У созданного заказа нельзя менять плательщика и клиента",
    CORP_PAYMENT_STATUS_NOT_ALLOWED: "Корпоративный заказ нельзя перевести в статус оплаты картой",
    CORP_KWH_REQUIRED: "Для завершения заказа укажите отпущенные кВт⋅ч",
    CORP_FINANCIALS_LOCKED: "Сумму завершённого корпоративного заказа меняет только корректировка: в ней указываются фактические кВт⋅ч, сумму система пересчитает сама",
    CORP_ACTOR_FORBIDDEN: "Корпоративный заказ может оформить только сам сотрудник или персонал",
    CORP_DELETE_CHARGED_ORDER: "Заказ с начислением компании нельзя удалить",
    CORP_ORDER_STATUS_INVALID: "Заказ нельзя завершить в текущем статусе",
    CORP_LEDGER_IMMUTABLE: "Проводки взаиморасчётов нельзя изменять или удалять",
    CORP_ORDER_COMPLETED_ON_INSERT: "Заказ нельзя создать сразу в статусе «Завершён» — статус меняется у уже созданного заказа",
    CORP_PHONE_INVALID: "Номер телефона не распознан: нужен российский номер — 10 цифр или 11 цифр с 7 или 8 в начале",
    CORP_CLIENT_NOT_FOUND: "Пользователь не найден — попросите сотрудника зарегистрироваться в приложении",
    CORP_PHONE_AMBIGUOUS: "С этим номером зарегистрировано несколько клиентов — привязку по нему создать нельзя, обратитесь к разработчикам",
    CORP_LINK_OVERLAP: "У сотрудника уже есть привязка к этой компании на этот период",
    CORP_LINK_PERIOD_INVALID: "Окончание привязки должно быть позже начала и не в прошлом",
    CORP_RATE_LIMITED: "Слишком много неуспешных поисков по телефону. Попробуйте позже",
    CORP_LINK_BLOCKED_BY_STAFF: "Блокировку установил оператор сервиса — снять её может только оператор",
    CORP_AMOUNT_INVALID: "Неверная сумма",
    CORP_INVOICE_EXISTS: "Счёт за этот период уже существует",
    CORP_INVOICE_NOT_VOIDABLE: "Этот счёт нельзя аннулировать",
    CORP_PAYMENT_ALREADY_VOIDED: "Оплата уже сторнирована",
    CORP_COMPANY_HAS_OPEN_ORDERS: "У компании есть незавершённые корпоративные заказы — архивировать нельзя",
    // не код БД: ответ не совпал с формой контракта (ошибка разбора Zod)
    CORP_DATA_SHAPE: "Сервер вернул данные в неожиданном формате — обратитесь к разработчикам",
    // edge corp-admin-manage (§4.5) и конверт upsert_tariff_pair (§3.8)
    EMAIL_EXISTS: "Этот email уже используется — укажите другой",
    VALIDATION: "Проверьте данные: корректный email, ФИО и пароль не короче 8 символов",
    UNAUTHORIZED: "Сессия истекла — войдите заново",
    FORBIDDEN: "Недостаточно прав для этого действия",
    NOT_FOUND: "Запись не найдена — обновите страницу",
    ROLE_NOT_HONOURED: "Не удалось создать учётную запись — обратитесь к разработчикам",
    AUTH_ERROR: "Сервис учётных записей не выполнил операцию — повторите попытку позже",
    REGISTER_FAILED: "Сервис учётных записей не выполнил операцию — повторите попытку позже",
    UPDATE_FAILED: "Сервис учётных записей не выполнил операцию — повторите попытку позже",
    INTERNAL: "Сервис учётных записей не выполнил операцию — повторите попытку позже",
};
/** SQLSTATE без символа. */
const SQLSTATE_TEXT = {
    "42501": "Недостаточно прав для этого действия",
    "23505": "Такая запись уже существует",
    "23514": "Значение не прошло проверку формата — проверьте введённые данные",
    "22023": "Некорректные данные запроса — проверьте заполнение формы",
    P0002: "Запись не найдена — обновите страницу",
};
/** Тексты, зависящие от экрана вызова (CCR-010: у `CP003` два смысла). */
const CONTEXT_TEXT = {
    orderCreate: {
        CORP_LINK_NOT_ACTIVE: "У клиента нет действующей привязки к компании — оформите заказ как физлицо",
    },
    orderDateChange: {
        CORP_LINK_NOT_ACTIVE: "Дату заказа нельзя изменить, пока привязка сотрудника к компании заблокирована",
    },
    companyRequisites: {
        "23505": "Компания с таким ИНН и КПП уже есть",
        "23514": "Проверьте формат реквизитов: ИНН — 10 или 12 цифр, КПП — 9, ОГРН — 13 или 15",
    },
    payment: {
        CORP_AMOUNT_INVALID: "Сумма оплаты должна быть больше нуля",
        "22023": "Заполните сумму, дату платежа и причину (для сторно)",
    },
    invoice: {
        "42501": "Недостаточно прав или дата «по состоянию на» в будущем запрещена настройками",
        CORP_INVOICE_NOT_VOIDABLE: "Аннулировать можно только выставленный счёт",
        P0002: "Счёт не найден — обновите страницу",
    },
    settlements: {
        CORP_AMOUNT_INVALID: "Сумма корректировки не может быть нулевой",
        "22023": "Укажите сумму и комментарий",
    },
    orderAdjust: {
        CORP_KWH_REQUIRED: "Укажите фактические кВт⋅ч",
        CORP_FINANCIALS_LOCKED: "Сумма завершённого корп-заказа меняется только через корректировку кВт⋅ч",
    },
    // Кабинет корп-админа (WP-DSP-3, TECH-CORP-008): kill-switch и типовые отказы `corp_link_*`.
    corpCabinet: {
        CORP_LINK_BLOCKED_BY_STAFF: "Блокировка установлена оператором сервиса — обратитесь к оператору",
        CORP_RATE_LIMITED: "Слишком много неуспешных поисков по телефону — попробуйте через час",
        CORP_COMPANY_NOT_ACTIVE: "Компания в архиве",
        "42501": "Доступ заблокирован",
    },
};
const SYMBOL_RE = /^[A-Z][A-Z0-9_]+$/;
export class B2BError extends Error {
    constructor(code, symbol) {
        const text = lookupText(code, symbol);
        super(text ?? "Неизвестная ошибка сервера");
        this.name = "B2BError";
        this.code = code;
        this.symbol = symbol;
        this.known = text !== null;
    }
}
function lookupText(code, symbol, context) {
    const byContext = context ? CONTEXT_TEXT[context] : undefined;
    if (byContext) {
        if (symbol && byContext[symbol])
            return byContext[symbol];
        if (code && byContext[code])
            return byContext[code];
    }
    if (symbol && SYMBOL_TEXT[symbol])
        return SYMBOL_TEXT[symbol];
    if (code && SQLSTATE_TEXT[code])
        return SQLSTATE_TEXT[code];
    return null;
}
const readString = (value) => typeof value === "string" && value.length > 0 ? value : null;
/**
 * Приводит ошибку к `B2BError`. Понимает: тело PostgREST / `PostgrestError` (`code`, `details`),
 * конверт legacy-RPC (`error_code`), тело edge-функции (`error`), уже готовый `B2BError`.
 */
export const toB2BError = (error) => {
    if (error instanceof B2BError)
        return error;
    if (typeof error !== "object" || error === null)
        return new B2BError(null, null);
    const source = error;
    const code = readString(source.code);
    const details = readString(source.details);
    const envelopeCode = readString(source.error_code);
    const edgeSymbol = readString(source.error);
    const detailsSymbol = details && SYMBOL_RE.test(details) ? details : null;
    const symbol = detailsSymbol ??
        (envelopeCode && SYMBOL_RE.test(envelopeCode) ? envelopeCode : null) ??
        (edgeSymbol && SYMBOL_RE.test(edgeSymbol) ? edgeSymbol : null) ??
        (code ? CODE_TO_SYMBOL[code] ?? null : null);
    return new B2BError(code, symbol);
};
/** Тело ответа CCR-008 (`{code, details}` в `data`) — отказ без исключения. */
export const isB2BErrorBody = (data) => {
    if (typeof data !== "object" || data === null)
        return false;
    const source = data;
    return typeof source.code === "string" && typeof source.details === "string" && !("linkId" in source);
};
/** Русский текст ошибки для экрана; неизвестная ошибка → `fallback` (без сырого текста БД). */
export const b2bErrorText = (error, fallback, context) => {
    const b2b = toB2BError(error);
    return lookupText(b2b.code, b2b.symbol, context) ?? fallback;
};
/** Символ ошибки для атрибута `data-error-code` (или код, если символа нет). */
export const b2bErrorCode = (error) => {
    const b2b = toB2BError(error);
    return b2b.symbol ?? b2b.code;
};
/**
 * Ошибка разбора ответа (Zod): наружу уходит понятный текст, технические детали — в консоль.
 * Иначе многострочный дамп Zod попал бы на экран (BR-UI-02).
 */
export const toDataShapeError = (error) => {
    if (error instanceof B2BError)
        return error;
    console.error("Ответ сервера не совпал с контрактом:", error);
    return new B2BError(null, "CORP_DATA_SHAPE");
};
/** Уведомление об ошибке B2B-операции: текст из карты, иначе `fallback`. */
export const onB2BError = (error, fallback, context) => {
    console.error(fallback, error);
    notification.error({
        message: "Ошибка",
        description: b2bErrorText(error, fallback, context),
    });
};
